import { useEffect } from "react";
import { type UseFormReturn } from "react-hook-form";
import { getConsentDefaultValues } from "@/components/site-builder/modules/CustomFormModule/utils/consent/getConsentDefaultValues";
import { getConsentValidationSchema } from "@/components/site-builder/modules/CustomFormModule/utils/consent/getConsentValidationSchema";
import { FormBuilderConsentFieldNames } from "@/constants/form-builder";
import { useTranslation } from "@/i18n/client";
import { type FormBuilderConsentConfig } from "@/types/form-builder";
import type { AnyZodObject } from "zod";

export interface UseCustomFormSetConsentProps {
  consentConfig?: FormBuilderConsentConfig | null;
  isShownConsentForm: boolean;
  form: UseFormReturn;
  setConsentValidationSchema: (value: AnyZodObject | null) => void;
}

export function useCustomFormSetConsent(props: UseCustomFormSetConsentProps) {
  const { t } = useTranslation("form-elements");

  const {
    consentConfig,
    isShownConsentForm,
    form,
    setConsentValidationSchema,
  } = props;
  const { reset } = form;

  useEffect(() => {
    if (isShownConsentForm && consentConfig) {
      const consentValidationSchema = getConsentValidationSchema(
        consentConfig,
        t,
      );
      const defaultValues = getConsentDefaultValues(consentConfig);

      setConsentValidationSchema(consentValidationSchema);
      reset((prev) => ({ ...prev, ...defaultValues }));
    } else {
      setConsentValidationSchema(null);
      reset((prev) => ({
        ...prev,
        [FormBuilderConsentFieldNames.CombineMarketing]: "",
        [FormBuilderConsentFieldNames.ThirdParty]: "",
        [FormBuilderConsentFieldNames.Marketing]: "",
      }));
    }
  }, [isShownConsentForm, consentConfig, reset, t, setConsentValidationSchema]);
}
